import psllogo from "./assets/psllogo.png";
export const brandingSettings = {
  primaryColor: '#fd5f07',
  secondaryColor: '#231e28',
  textcolorPrimary:"#212121",  
  textcolorSecondary:"#999",  
  headercolor: "#212121",
  logoPath: psllogo,

  primaryColorDark: "#fd5f07b3",
  secondaryColorDark: '#fd5f07b3',
  textcolorPrimaryDark:"#aaa",
  textcolorSecondaryDark:"#fff",
  headercolorDark: "#010101",
  baseFont: "'Arial',Helvetica,sans-serif",//"'Franklin Gothic Medium','Arial Narrow', Arial"
  baseFontSize: 16,
  bodyFontSize: 16,
};